var map = {
	"./aircon-truck.png": 1275,
	"./airstarter.png": 1276,
	"./airtug.png": 1277,
	"./ambulance.png": 1278,
	"./bed.png": 1279,
	"./bicycle.png": 1280,
	"./boom-lift.png": 1281,
	"./bowser.png": 1282,
	"./boy.png": 1283,
	"./bulldozer.png": 1284,
	"./bus.png": 1285,
	"./car.png": 1286,
	"./catering-hi-lift.png": 1287,
	"./cement-mixer.png": 1288,
	"./crane.png": 1289,
	"./defueller.png": 1290,
	"./excavator.png": 1291,
	"./female.png": 1292,
	"./fire-tender.png": 1293,
	"./forklift.png": 1294,
	"./galley-cart.png": 1295,
	"./garbage-wagon.png": 1296,
	"./girl.png": 1297,
	"./helmet.png": 1298,
	"./infant.png": 1299,
	"./invalid-passenger-lift.png": 1300,
	"./joint-pallet-container-loader.png": 1301,
	"./lavatory-truck.png": 1302,
	"./lorry.png": 1303,
	"./maintenance-platform.png": 1304,
	"./male.png": 1305,
	"./mechanical-sweeper.png": 1306,
	"./mini-bus.png": 1307,
	"./mobile-gpu.png": 1308,
	"./motorcycle.png": 1309,
	"./others.png": 1310,
	"./passenger-step.png": 1311,
	"./pmd.png": 1312,
	"./police-car.png": 1313,
	"./prime-mover.png": 1314,
	"./recovery-truck.png": 1315,
	"./scissor-lift.png": 1316,
	"./scooter.png": 1317,
	"./scrubber.png": 1318,
	"./seatbelt.png": 1319,
	"./ship.png": 1320,
	"./skyloader.png": 1321,
	"./storage-bin.png": 1322,
	"./tanker.png": 1323,
	"./tractor.png": 1324,
	"./trailer.png": 1325,
	"./tram.png": 1326,
	"./transporter.png": 1327,
	"./van.png": 1328,
	"./water-truck.png": 1329
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1274;